export const isL1 = () => window.location.href.includes('.l1.');
